import {createApp} from "vue";

export default {
    name: 'catalogs',
    _el: null,
    init() {
        this._el = document.querySelector('#js_catalogs');
        
        if(this._el){
            this.run(this._el);
        }
    },

    run (element)
    {
        const json = JSON.parse(element.dataset.json);

        // console.log(json);
        if (typeof json.brands === 'undefined' || typeof json.catalogs === 'undefined') {
            return false;
        }

        createApp({
            delimiters: ['@{', '}'],
            data()  {
                return {
                    brand : '',
                    brands : json.brands,
                    catalogs : json.catalogs,
                    resource : 'caravans',
                    brandIndex : {
                        'caravans' : new Set(),
                        'caravan_trailers' : new Set(),
                    }
                }
            },

            computed : {
                publicBrands()
                {
                    const publicBrands = [];

                    if (typeof this.brands[this.resource] === 'object') {
                        for (let brandId in this.brands[this.resource]) {
                            if (this.brandIndex[this.resource].has(parseInt(brandId))) {
                                publicBrands.push( {
                                    id : brandId,
                                    label : this.brands[this.resource][brandId]
                                });
                            }
                        }
                    }

                    return publicBrands;
                },

                publicCatalogs()
                {
                    if (this.brand && this.resource) {
                        // make object to array
                        const tmp = this.convertToArray(this.catalogs[this.resource]);
                        // filter by brand id
                        return tmp.filter((c) => c.brand_id == this.brand);
                    } else {
                        return [];
                    }
                }
            },

            created()
            {
                this.setupBrandIndex();
            },

            methods:
            {
                convertToArray(object)
                {
                    return Object.values(object);
                },

                setupBrandIndex()
                {
                    for (let resource in this.catalogs) {
                        let items = this.convertToArray(this.catalogs[resource]);
                        items.forEach((item) => this.brandIndex[resource].add(item.brand_id));
                    }
                },

                filterLink(link)
                {
                    const url = link.replace('https://issuu.com/tibemolde/docs/', 'https://e.issuu.com/embed.html?d=');

                    return  url+'&hideIssuuLogo=true&u=tibemolde';
                },

                changedResource()
                {
                    this.brand = '';
                }

            }
        }).mount(element);
    }
}